import { render, staticRenderFns } from "./legal-info.vue?vue&type=template&id=58d5330e"
import script from "./legal-info.vue?vue&type=script&lang=ts"
export * from "./legal-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d5330e')) {
      api.createRecord('58d5330e', component.options)
    } else {
      api.reload('58d5330e', component.options)
    }
    module.hot.accept("./legal-info.vue?vue&type=template&id=58d5330e", function () {
      api.rerender('58d5330e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/legal-info.vue"
export default component.exports